import { DeliveryOptionsEnum, } from '@as-react/common-types';
import { isAxiosError } from 'axios';
import { all, call, getContext, put, takeLatest } from 'redux-saga/effects';
import BuyAPI from '../../../api/buy/BuyAPI';
import CheckoutAPI from '../../../api/CheckoutAPI';
import CustomerApi from '../../../api/customer/CustomerApi';
import ProductDetailAPI from '../../../api/ProductDetailAPI';
import { CheckoutActionTypes } from '../../../enums/ActionEnums';
import MonetateUtil from '../../../util/MonetateUtil';
import ReevooUtil from '../../../util/ReevooUtil';
import { getQuerystringByName } from '../../../util/URLParamUtil';
import { analyticsActions } from '../../analytics/actions/AnalyticsActions.creators';
import checkoutActions from '../actions/CheckoutActions.creators';
export const getCheckoutState = (state) => state.checkout.state;
export function* analyticsLoginCheckoutSaga() {
    yield takeLatest(CheckoutActionTypes.LOGIN_ANALYTICS, analyticsLoginCheckout);
}
export function* analyticsLoginCheckout() {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        const analyticsAdobeTagManagerData = yield call(CheckoutAPI.checkoutStepDtm, servicesEndpoint, defaultRequestParams);
        yield put(checkoutActions.createAnalyticsSuccessAction(analyticsAdobeTagManagerData));
    }
    catch (_a) { }
}
export function* orderConfirmationSaga() {
    yield takeLatest(CheckoutActionTypes.GET_CONFIRMATION_ORDER, orderConfirmation);
}
export function* orderConfirmation() {
    try {
        const aemConfigurationContext = yield getContext('aemConfiguration');
        const { currency, servicesEndpoint, defaultRequestParams } = aemConfigurationContext;
        const orderId = getQuerystringByName(window.location.search, 'orderID');
        yield put(checkoutActions.createAnalyticsConfirmationPageAction());
        const order = yield call(BuyAPI.getConfirmedOrder, servicesEndpoint, defaultRequestParams, orderId);
        const newsletterPreferences = yield call(CustomerApi.getNewsletterPreferences, servicesEndpoint, defaultRequestParams, order.customerUUID);
        if (newsletterPreferences.newCustomer) {
            const profile_details = {
                email_newsletter: true,
            };
            yield call(CustomerApi.updatePreferences, servicesEndpoint, defaultRequestParams, profile_details, order.contactPerson);
        }
        const mappedProducts = yield all(order.products.map(product => call(ProductDetailAPI.fetchProductForConfirmation, aemConfigurationContext.servicesApi, aemConfigurationContext.servicesApiPrefixAemServices, aemConfigurationContext.mainWebShop, aemConfigurationContext.fictiveWebShop, aemConfigurationContext.lang, product)));
        yield put(checkoutActions.createSetConfirmationOrderAction(Object.assign(Object.assign({}, order), { mappedProducts })));
        yield put(checkoutActions.createSetNewsletterPreferencesAction(newsletterPreferences));
        yield put(checkoutActions.createSetConfirmationOrderErrorAction(null));
        yield put(checkoutActions.createSetConfirmationIsCollectStoreAction(order.deliveryOption === DeliveryOptionsEnum.COLLECT_STORE));
        ReevooUtil.setReevooTracking(order);
        MonetateUtil.pushOrderConfirmationEvent(mappedProducts, currency, orderId);
    }
    catch (error) {
        if (isAxiosError(error)) {
            yield put(checkoutActions.createSetConfirmationOrderErrorAction(error.message));
        }
    }
}
export function* analyticsConfirmationPageSaga() {
    yield takeLatest(CheckoutActionTypes.ANALYTICS_CONFIRMATION_PAGE_STEP, analyticsConfirmationPage);
}
export function* analyticsConfirmationPage() {
    try {
        const { servicesEndpoint, defaultRequestParams } = yield getContext('aemConfiguration');
        const orderId = getQuerystringByName(window.location.search, 'orderID');
        const purchaseStepInformation = yield call(BuyAPI.getAnalyticsPurchaseStepInformation, servicesEndpoint, defaultRequestParams, orderId);
        const dtmPurchaseStepInformation = yield call(BuyAPI.getDtmAnalyticsPurchaseStepInformation, servicesEndpoint, defaultRequestParams, orderId);
        yield put(analyticsActions.confirmationPage());
        if (purchaseStepInformation) {
            yield put(checkoutActions.createAnalyticsMergeConfirmationPageAction(dtmPurchaseStepInformation));
            yield put(analyticsActions.googleConfirmationPage(purchaseStepInformation));
        }
    }
    catch (_a) { }
}
export default function* checkoutSaga() {
    yield all([analyticsLoginCheckoutSaga(), orderConfirmationSaga(), analyticsConfirmationPageSaga()]);
}
